import "slick-slider";

// About USTA page USTA National Champions carousel
$("#usta-national-champions-carousel").slick({
    arrows: true,
    autoplay: true,
    dots: true,
    draggable: true,
    swipe: true,
    pauseOnHover: true,
    cssEase: "ease",
    accessibility: true,
    autoplaySpeed: 7000,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 2200,
            settings: {
                arrows: true,
                slidesToShow: 3,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 1441,
            settings: {
                arrows: true,
                slidesToShow: 3,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 1200,
            settings: {
                arrows: true,
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 768,
            settings: {
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
});

// About USTA page Hall of Fame carousel
$("#hall-of-fame-carousel").slick({
    arrows: true,
    autoplay: true,
    dots: true,
    draggable: true,
    swipe: true,
    pauseOnHover: true,
    cssEase: "ease",
    accessibility: true,
    autoplaySpeed: 7000,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 2200,
            settings: {
                arrows: true,
                slidesToShow: 3,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 1441,
            settings: {
                arrows: true,
                slidesToShow: 3,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 1200,
            settings: {
                arrows: true,
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 768,
            settings: {
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
});

// About USTA - Giving Back page USTA Creative Challenge carousel
$("#usta-creative-challenge-carousel").slick({
    arrows: true,
    autoplay: true,
    dots: true,
    draggable: true,
    swipe: true,
    pauseOnHover: true,
    cssEase: "ease",
    accessibility: true,
    autoplaySpeed: 7000,
    infinite: true,
    // slidesToShow: 3,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 2200,
            settings: {
                arrows: true,
                // slidesToShow: 3,
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 1441,
            settings: {
                arrows: true,
                // slidesToShow: 3,
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 1200,
            settings: {
                arrows: true,
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 992,
            settings: {
                arrows: true,
                // slidesToShow: 2,
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 768,
            settings: {
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
});
